var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"churn-validate-action-popup"},[_c('churn-popup',{attrs:{"buttons":_vm.buttonOptions,"back-action":_vm.back},scopedSlots:_vm._u([{key:"popup-content",fn:function(){return [_c('churn-validate-action-popup-content')]},proxy:true}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af45d410","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/churn/ChurnValidateActionPopup.vue
// module id = null
// module chunks = 